export enum A48UserStatus {
    NOACTION = -1,
    OVERRIDE = 0,
    PENDING = 1,
    ERROR = 2,
    SUCCESS = 3,
    REMOVED = 4,
    PARAAPPROVED = 5,
    EXCLUDED = 6
}